// The installed app reports itself to the account, once per launch (INSTALL.md
// §4.4): so the offer stops on every device the moment there is an install
// anywhere, including the Safari tab whose storage this app cannot see. The
// account keeps the first report, so a report every launch costs one write
// and changes nothing after the first.

import { useEffect } from 'react';
import { reportInstall } from '../data/install';
import { useSession } from '../data/session';
import { isInstalled } from './platform';

export function InstalledReporter() {
  const { session } = useSession();
  const userId = session?.userId ?? null;
  useEffect(() => {
    if (userId !== null && isInstalled()) void reportInstall('installed');
  }, [userId]);
  return null;
}
